import type { IGalleryProps } from './Contracts/contracts';

export async function MountGallery(props: IGalleryProps, el: Element) {
	const module = await import('./Components/Gallery');
	module.MountGallery(props, el);
}

(window as any).MountGallery = MountGallery;
